import getFetcher from 'api/utils/getFetcher';
import { useMemo } from 'react';
import useSWR from 'swr';
import type { LegacyOrganization } from 'types/legacyDashboard';

export interface UserOrganizationsResult {
  success: boolean;
  limit: number;
  size: number;
  continues: boolean;
  lastid: OrgId;
  data: Array<LegacyOrganization>;
}

export interface UserOrganizationsError {}

const useUserOrganizations = (userId?: UserId) => {
  const queryParams = new URLSearchParams({ limit: '1000', userid: `${userId}` });
  const url = userId ? `${process.env.VITE_API_ROOT}/organizations/?${queryParams}` : null;

  const { data, error, isLoading, mutate, isValidating } = useSWR<
    UserOrganizationsResult,
    UserOrganizationsError
  >(url, getFetcher);

  const organizations = useMemo(() => data?.data ?? [], [data]);

  return {
    organizations,
    error,
    isLoading,
    mutate,
    isValidating,
  };
};

export default useUserOrganizations;
